import styled from 'styled-components';

export const BGWrap = styled.div`
  width: 100%;
  padding-top: ${({ width, height }) => `${(height / width) * 100}%`};
  border-top: none;
  border-bottom: none;
  box-sizing: border-box;
  background: url(${({ imgUrl }) => imgUrl}) center center no-repeat;
  background-size: cover;
  position: relative;
`;

export const EventApplyBtn = styled.button`
  border: none;
  box-sizing: border-box;
  position: absolute;
  width: 90.985%;
  top: 94.5%;
  left: 4.5%;
  height: 4%;
  background: transparent;
`;
